import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { ScholarshipService } from 'src/app/services/scholarship/scholarship.service';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'app-scholarship-form',
  templateUrl: './scholarship-form.component.html',
  styleUrls: ['./scholarship-form.component.scss'],
})
export class ScholarshipFormComponent implements OnInit {
  constructor(private SCHOLARSHIP: ScholarshipService) {}

  scholarshipForm: FormGroup;
  cellForm: FormControl;
  goalsAndAspirationsForm: FormControl;
  favoriteNHForm: FormControl;

  coachReq = {
    filename: undefined,
    file: undefined,
  };
  teacherReq = {
    filename: undefined,
    file: undefined,
  };
  displayAttachmentWarning;
  teacherUploaded = false;
  coachUploaded = false;
  submissionCreated = false;
  processingForm = false;

  displayConfirmation = false;
  showSuccess = false;
  submitting = false;
  submitAttempt = false;
  motherChecked = false;
  fatherChecked = false;
  gaurdianChecked = false;
  otherRelationChecked = false;
  fileName;

  private subscriptions = new Subscription();

  public grades = ['K', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  ngOnInit() {
    this.SCHOLARSHIP.getCollection()
      .valueChanges()
      .subscribe((data) => console.log(data));
    this.scholarshipForm = new FormGroup({
      first: new FormControl('', Validators.required),
      last: new FormControl('', Validators.required),
      dob: new FormControl('', Validators.required),
      usatf: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      grade: new FormControl(''),
      school: new FormControl('', Validators.required),
      parent: new FormGroup({
        first: new FormControl('', Validators.required),
        last: new FormControl('', Validators.required),
        mother: new FormControl('', this.validateParentRelation()),
        father: new FormControl('', this.validateParentRelation()),
        gaurdian: new FormControl('', this.validateParentRelation()),
        other: new FormControl('', this.validateParentRelation()),
        otherTxt: new FormControl(''),
        email: new FormControl('', Validators.required),
        cell: new FormControl('', [
          Validators.pattern(/^\(\d{3}\)-\d{3}-\d{4}$/),
          Validators.required,
        ]),
      }),
      essays: new FormGroup({
        goalsAndAspirations: new FormControl('', [
          Validators.required,
          this.validate300WordEssay(),
        ]),
        favoriteNH: new FormControl('', Validators.required),
      }),
    });

    this.cellForm = this.scholarshipForm
      .get('parent')
      .get('cell') as FormControl;

    this.goalsAndAspirationsForm = this.scholarshipForm
      .get('essays')
      .get('goalsAndAspirations') as FormControl;

    this.favoriteNHForm = this.scholarshipForm
      .get('essays')
      .get('favoriteNH') as FormControl;

    this.handleCellForm();
  }

  validateParentRelation() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (
        this.motherChecked ||
        this.fatherChecked ||
        this.gaurdianChecked ||
        this.otherRelationChecked
      ) {
        return null;
      }
      return { notChecked: true };
    };
  }

  validateCheckbox(control: AbstractControl): { [key: string]: any } | null {
    if (control.value) {
      return null;
    }
    return { notChecked: true };
  }

  validate300WordEssay() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value.split(' ').length <= 300) {
        return null;
      }
      return { length: true };
    };
  }

  handleCheckbox(event, relation) {
    if (relation === 'mother') {
      this.motherChecked = event.checked;
    } else if (relation === 'father') {
      this.fatherChecked = event.checked;
    } else if (relation === 'gaurdian') {
      this.gaurdianChecked = event.checked;
    } else {
      this.otherRelationChecked = event.checked;
    }
    this.scholarshipForm.get('parent').get('mother').updateValueAndValidity();
    this.scholarshipForm.get('parent').get('father').updateValueAndValidity();
    this.scholarshipForm.get('parent').get('gaurdian').updateValueAndValidity();
    this.scholarshipForm.get('parent').get('other').updateValueAndValidity();
  }

  handleCellForm() {
    let validNumber = new RegExp(/^\d{10}$/);
    this.subscriptions.add(
      this.cellForm.valueChanges.subscribe((number) => {
        if (validNumber.test(number)) {
          this.cellForm.patchValue(
            '(' +
              number.substring(0, 3) +
              ')-' +
              number.substring(3, 6) +
              '-' +
              number.substring(6, 10)
          );
        }
      })
    );
  }

  onFileSelected(event, type) {
    if (type === 'teacher') {
      this.teacherReq.file = event.target.files[0];
      this.teacherReq.filename = event.target.files[0].name;
    } else {
      this.coachReq.file = event.target.files[0];
      this.coachReq.filename = event.target.files[0].name;
    }
  }

  onFormSubmit() {
    if (!this.otherRelationChecked) {
      this.scholarshipForm.get('parent').get('otherTxt').clearValidators();
      this.scholarshipForm.get('parent').get('otherTxt').reset();
    }
    if (this.scholarshipForm.valid) {
      if (this.checkAttachments()) {
        this.processingForm = true;
        let id = uuid();
        let form = this.scholarshipForm.value;
        form.id = id;
        this.SCHOLARSHIP.uploadAttachments(this.teacherReq.file, id).then(
          () => {
            this.teacherUploaded = true;
          }
        );
        this.SCHOLARSHIP.uploadAttachments(this.coachReq.file, id).then(
          (res) => {
            this.coachUploaded = true;
          }
        );
        this.SCHOLARSHIP.createScholarshipSubmission(form).then((res) => {
          this.submissionCreated = true;
        });
      }
    }
  }

  checkAttachments() {
    if (this.teacherReq.file && this.coachReq.file) {
      this.displayAttachmentWarning = false;
      console.log(this.teacherReq);
      return true;
    }
    console.log(this.teacherReq);
    this.displayAttachmentWarning = true;
    return false;
  }
}
